module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.index.title')) + " (" + _vm._s(_vm.adjustments.pagination.totalCount) + ")")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 16
    }
  }, [_c('div', {
    staticClass: "listOptions pull-right"
  }, [_c('v-text', {
    staticClass: "searchForm",
    attrs: {
      "name": "search",
      "type": "text",
      "translation": "search.title",
      "value": _vm.search
    },
    on: {
      "keydown": _vm.onChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "flex stretch wrap"
  }, [(_vm.adjustments.items.length === 0) ? _c('v-no-data', [_vm._v("\n        " + _vm._s(_vm.$t('static.defaultText.adjustment.noDataMsg')) + "\n        "), (!_vm.bridgeStockWriteBlocked) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.adjustment.stock.create'
      }
    }
  }, [_vm._v("\n           "), _c('el-button', [_vm._v("\n            " + _vm._s(_vm.$t('static.defaultText.adjustment.noDataBtn')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.adjustments.items), function(p, i) {
    return _c('v-card', {
      key: i,
      attrs: {
        "wide": true
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editAdjustment(p)
        }
      }
    }, [_c('div', {
      staticClass: "full-w flex wrap client-title-container margin-b-10"
    }, [_c('img', {
      staticClass: "client-img margin-b-10",
      attrs: {
        "src": require("./../../../../../assets/images/stock.png"),
        "alt": ("" + (p.code))
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "cardTitle"
    }, [_vm._v(_vm._s(("" + (p.code))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.code')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.code || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.qty')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.total_qty || '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.warehouse')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(p.warehouseName))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.createdAt')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s(_vm.formatDate(p.createdAt, 'DD-MM-YYYY')))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.adjustmentType')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s((p.adjustmentType) ? _vm.$t(("form.adjustment.adjustmentTypeList." + (p.adjustmentType))) : '-'))])], _c('br'), _vm._v(" "), [_c('label', {
      staticClass: "cardLabel"
    }, [_vm._v(_vm._s(_vm.$t('static.adjustment.info.status')) + " ")]), _c('span', {
      staticClass: "cardContent"
    }, [_vm._v(_vm._s((p.status) ? _vm.$t(("form.adjustment.adjustmentStatus." + (p.status))) : '-'))])], _c('br')], 2)
  })], 2)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "sizePerPage": _vm.perPage,
      "pagination": _vm.adjustments.pagination,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c78f358","hasScoped":true}!./src/app/pages/withNavigation/adjustment/index/index.html
// module id = 2910
// module chunks = 1